import { render, staticRenderFns } from "./TraceabilityModal.vue?vue&type=template&id=70cb6c84&"
import script from "./TraceabilityModal.vue?vue&type=script&lang=js&"
export * from "./TraceabilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports